import { NextSeo } from 'next-seo';
import * as React from 'react';

import { Video } from '@/lib/videos';

import FAQSection from '@/components/landing/FAQSection';
import FeaturesSection, { Feature } from '@/components/landing/FeaturesSection';
import GetStartedSection from '@/components/landing/GetStartedSection';
import HeroSection from '@/components/landing/HeroSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import Layout from '@/components/layout/Layout';

const ForEditorsPage: React.FC<{ videos: Video[] }> = ({ videos }) => {
  const title = `AI-Powered Clip Making Software`;
  return (
    <>
      <NextSeo title={title} />
      <Layout mode='light'>
        <main>
          <HeroSection
            pageType='For Editors'
            titleTop='AI-Powered Clip Making'
            titleBottom='Software'
            subtitle='We use AI to automatically find the best moments of your podcast and give you ready-to-post clips within minutes.'
          />
          <FeaturesSection>
            <Feature
              name='Speed up your workflow'
              description='Seamlessly handle more clients and a bigger workload by letting us do the heavy lifting.'
              image='/images/speed-up-workflow.png'
              alt='Hero image'
            />
            <Feature
              name='Take on more clients'
              description='Seamlessly handle more clients and a bigger workload by letting us do the heavy lifting.'
              image='/images/new-clients.png'
              alt='Hero image'
              flipped
            />
            <Feature
              name='Faster turnaround'
              description='Deliver high-quality clips faster and meet demanding deadlines with ease.'
              image='/images/faster-turnaround.png'
              alt='Hero image'
            />
            <Feature
              name='Full editing control'
              description='Customize clips with our easy-to-use editor to make them match your own branding and style.'
              image='/images/full-control.png'
              alt='Hero image'
              flipped
            />
          </FeaturesSection>
          <TestimonialsSection />
          <FAQSection />
          <GetStartedSection />
        </main>
      </Layout>
    </>
  );
};

export default ForEditorsPage;
